import { InfoTooltip, Translation } from '@ps/web-shared-components';
import React from 'react';

import HandIcon from '@swf/core/assets/icons/hand-icon.svg';

import PanicButtonVegas from '../PanicButtonVegas/PanicButtonVegas';

import {
  TXTWCL_24_hour_lockout,
  TXTWCL_This_is_a_24_hour_one_click_pa_ELL,
  TXTWCL_You_will_not_be_able_to_revers_ELL_1
} from './SelfExclusionTooltip.messages.json';
import styles from './SelfExclusionTooltip.scss';

const SelfExclusionTooltip: React.FC = () => (
  <InfoTooltip
    addHoverEffect
    offset={[0, 15]}
    tooltipClassName={styles.selfExclusionTooltip}
    arrowClassName={styles.selfExclusionTooltipArrow}
    content={
      <div className={styles.infoContainer}>
        <HandIcon />
        <p>
          <Translation tagName="b" {...TXTWCL_24_hour_lockout} />
        </p>
        <Translation tagName="p" {...TXTWCL_This_is_a_24_hour_one_click_pa_ELL} />
        <Translation tagName="p" {...TXTWCL_You_will_not_be_able_to_revers_ELL_1} />
      </div>
    }
  >
    <PanicButtonVegas />
  </InfoTooltip>
);

export default SelfExclusionTooltip;
